import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Gift = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M18.25 12.7495H12.75V20.2495H17C17.3314 20.2495 17.6494 20.1185 17.8838 19.8843C18.1182 19.6499 18.25 19.331 18.25 18.9995V12.7495ZM5.75 18.9995C5.75 19.331 5.88179 19.6499 6.11621 19.8843C6.35061 20.1185 6.66861 20.2495 7 20.2495H11.25V12.7495H5.75V18.9995ZM20.25 8.99951C20.2498 8.86164 20.1379 8.74951 20 8.74951H12.75V11.2495H20C20.1381 11.2495 20.25 11.1376 20.25 10.9995V8.99951ZM3.75 10.9995C3.75 11.1376 3.86193 11.2495 4 11.2495H11.25V8.74951H4C3.86207 8.74951 3.75024 8.86164 3.75 8.99951V10.9995ZM18.25 5.49951C18.2499 5.03554 18.0654 4.59029 17.7373 4.26221C17.4091 3.93416 16.964 3.74951 16.5 3.74951H16.4873C15.7911 3.73738 15.0405 4.07215 14.3447 4.84521C13.8064 5.44343 13.3428 6.26405 13.002 7.24951H16.5C16.964 7.24951 17.4091 7.06581 17.7373 6.73779C18.0655 6.4096 18.25 5.96364 18.25 5.49951ZM5.75879 5.67334C5.79865 6.07379 5.97564 6.45073 6.2627 6.73779C6.59086 7.06581 7.036 7.24951 7.5 7.24951H10.998C10.6572 6.26405 10.1936 5.44343 9.65527 4.84521C8.95952 4.07215 8.20886 3.73738 7.5127 3.74951L7.5 3.75049V3.74951C7.03597 3.74951 6.59086 3.93416 6.2627 4.26221C5.93461 4.59029 5.75012 5.03554 5.75 5.49951L5.75879 5.67334ZM19.75 5.49951C19.75 6.12445 19.5696 6.73099 19.2383 7.24951H20C20.9664 7.24951 21.7498 8.03321 21.75 8.99951V10.9995C21.75 11.966 20.9665 12.7495 20 12.7495H19.75V18.9995C19.75 19.7289 19.4601 20.4291 18.9443 20.9448C18.4286 21.4604 17.7292 21.7495 17 21.7495H7C6.27078 21.7495 5.57136 21.4604 5.05566 20.9448C4.53994 20.4291 4.25 19.7289 4.25 18.9995V12.7495H4C3.0335 12.7495 2.25 11.966 2.25 10.9995V8.99951C2.25024 8.03321 3.03365 7.24951 4 7.24951H4.76172C4.45891 6.77556 4.282 6.22849 4.25391 5.66064L4.25 5.49951C4.25012 4.63772 4.59276 3.81105 5.20215 3.20166C5.81162 2.5923 6.63815 2.24951 7.5 2.24951V2.25146C8.7282 2.23443 9.86405 2.83413 10.7705 3.84131C11.2492 4.37323 11.6606 5.0148 12 5.73389C12.3394 5.0148 12.7508 4.37323 13.2295 3.84131C14.136 2.83413 15.2718 2.23443 16.5 2.25146V2.24951C17.3619 2.24951 18.1884 2.5923 18.7979 3.20166C19.4072 3.81105 19.7499 4.63772 19.75 5.49951Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  )
}
